import { render, staticRenderFns } from "./rosterspotNew.vue?vue&type=template&id=4cd7f705&scoped=true"
import script from "./rosterspotNew.vue?vue&type=script&lang=js"
export * from "./rosterspotNew.vue?vue&type=script&lang=js"
import style0 from "./rosterspotNew.vue?vue&type=style&index=0&id=4cd7f705&prod&lang=css"
import style1 from "./rosterspotNew.vue?vue&type=style&index=1&id=4cd7f705&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd7f705",
  null
  
)

export default component.exports